import { formatCurrency, fromCents } from 'components/Widget/shared/currency';
import { frequencyPhrase, SUMMARY_COPY } from './constants';
import type { PaycheckPanel } from './types';

interface PaycheckCalculatorSummaryProps {
  panel: PaycheckPanel;
}

/** Announcement only: the panel stays on screen, so repeating the take-home figure in view would duplicate it. */
export const PaycheckCalculatorSummary = ({ panel }: PaycheckCalculatorSummaryProps) => (
  <p className="sr-only">
    {SUMMARY_COPY.takeHome(
      frequencyPhrase(panel.payFrequency),
      formatCurrency(fromCents(panel.result.takeHome)),
      formatCurrency(fromCents(panel.result.gross)),
    )}
  </p>
);
